import { createBuiltInComponentMeta, withComponentMeta } from '../../internal/component-meta';
import { Spinner as SpinnerComponent } from './Spinner';
export const Spinner = withComponentMeta(SpinnerComponent, createBuiltInComponentMeta('Spinner'));
//# sourceMappingURL=index.js.map